import { render } from "./menu.vue?vue&type=template&id=a380d422"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a380d422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a380d422', __exports__)) {
    api.reload('a380d422', __exports__)
  }
  
  module.hot.accept("./menu.vue?vue&type=template&id=a380d422", () => {
    api.rerender('a380d422', render)
  })

}


export default __exports__